import axios, { AxiosResponse } from "axios";
import { API_URL } from "../constants";
import { UserInfo } from "../contexts/UserInfoContext";
import { resolveAccessToken } from "./Auth";
import { PromptComponent } from '@common/domain/types';
export type { PromptComponent };

export async function getAllComponents(userInfo?: UserInfo): Promise<PromptComponent[]> {
  let token: string | null = null;
  if (userInfo?.accessToken) {
    token = await resolveAccessToken(userInfo.accessToken);
    if (!token) throw new Error("SESSION_EXPIRED");
  }

  try {
    const response: AxiosResponse = await axios.get(
      `${API_URL}/prompts`,
      token
        ? { headers: { Authorization: `Bearer ${token}` } }
        : undefined
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw error;
  }
}

export async function getComponent(userInfo: UserInfo | undefined, type: string, id: string): Promise<PromptComponent | undefined> {
  let token: string | null = null;
  if (userInfo?.accessToken) {
    token = await resolveAccessToken(userInfo.accessToken);
    if (!token) throw new Error("SESSION_EXPIRED");
  }

  try {
    const response: AxiosResponse = await axios.get(
      `${API_URL}/prompts/${type}/${id}`,
      token
        ? { headers: { Authorization: `Bearer ${token}` } }
        : undefined
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateComponent(
  userInfo: UserInfo | undefined,
  type: string,
  id: string,
  updates: Partial<PromptComponent>
) {
  const token = await resolveAccessToken(userInfo?.accessToken);
  if (token) {
    try {
      const response: AxiosResponse = await axios.put(
        `${API_URL}/prompts/${type}/${id}`,
        updates,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  } else return undefined;
}

export async function createComponent(
  userInfo: UserInfo | undefined,
  component: PromptComponent
) {
  const token = await resolveAccessToken(userInfo?.accessToken);
  if (token) {
    try {
      const response: AxiosResponse = await axios.post(
        `${API_URL}/prompts`,
        component,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  } else return undefined;
}

export async function deleteComponent(
  userInfo: UserInfo | undefined,
  type: string,
  id: string
) {
  const token = await resolveAccessToken(userInfo?.accessToken);
  if (token) {
    try {
      const response: AxiosResponse = await axios.delete(
        `${API_URL}/prompts/${type}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  } else return undefined;
}
